import './index.css'
import { setKtx2TranscoderPath } from '@webxr-jp/avatar-optimizer'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { KTX2_TRANSCODER_PATH } from './constants/ktx2'
import { initSentry } from './lib/sentry'

initSentry()

// KTX2 トランスコーダーの配信元をアプリ全体の既定値として設定する。
// 各読み込み箇所では設定済みの KTX2Loader を明示的に渡しているが、
// 渡し忘れた箇所があっても CDN（既定値）に落ちないようにするための保険。
setKtx2TranscoderPath(KTX2_TRANSCODER_PATH)

// デプロイ後のアセット不整合時に自動リロード
window.addEventListener('vite:preloadError', () => {
  const key = `preload-retry:${window.location.pathname}`
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, '1')
    window.location.reload()
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  // 開発時のWebSocket接続問題を回避するため一時的にStrictModeを無効化
  // 本番環境では問題ないため、必要に応じて有効化可能
  import.meta.env.DEV ? (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  ) : (
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  ),
)
